import { Card, Typography, Divider, Tabs } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import BranchAddress from "./AddbranchTab/BranchAddress";
import BranchTimeSlot from "./AddbranchTab/BranchTimeSlot";
import BranchHoliday from "./AddbranchTab/BranchHoliday";
import { useEffect, useState } from "react";
import AssociateDropzone from "../../AssociateDropzone";
const AddBranch = () => {
  const navigate = useNavigate();
  let { id, branchId } = useParams();
  let getItem = localStorage.getItem("currentTab");
  const [defaultIndex, setDefaultIndex] = useState(getItem ? getItem : "1");

  useEffect(() => {
    return () => {
      localStorage.removeItem("currentTab");
    };
  }, []);

  const onTabChange = (key) => {
    setDefaultIndex(key);
  };

  const goBack = () => {
    localStorage.setItem("currentTab", "2");
    navigate("/edit-vendor/" + id);
  };

  return (
    <>
      <Card className="res-time">
        <Typography className="text-xl font-semibold" align={"left"}>
          <LeftOutlined className="mr-2" onClick={() => goBack()} />
          {branchId ? "Edit Branch" : "Add Branch"}
        </Typography>
        <Divider />
        <div className="min-h-[calc(100vh_-_305px)]">
          <Tabs activeKey={defaultIndex} onChange={onTabChange}>
            <Tabs.TabPane tab={"Branch Address"} key={1}>
              {(defaultIndex === 1 || defaultIndex === '1') && <BranchAddress />}
            </Tabs.TabPane>
            {branchId ? (
              <>
                <Tabs.TabPane tab={"Working Hours"} key={2}>
                  {(defaultIndex === 2 || defaultIndex === '2') && <BranchTimeSlot />}
                </Tabs.TabPane>
                <Tabs.TabPane tab={"Holidays"} key={3}>
                  {(defaultIndex === 3 || defaultIndex === '3') && <BranchHoliday />}
                </Tabs.TabPane>
              </>
            ) : null}
            <Tabs.TabPane tab={"Drop zone"} key={4}>
              {(defaultIndex === 4 || defaultIndex === '4') && <AssociateDropzone />}
            </Tabs.TabPane>
          </Tabs>
        </div>
        <Divider />
      </Card>
    </>
  );
};
export default AddBranch;
